import { GiftIcon } from './GiftIcon';

/**
 * author: Simran
 * id 62403C7B-F20E-489B-8835-28F7544D9712
 * name gift
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gift.svg
 * tags
 * - Holiday 
 */
export const PresentIcon = GiftIcon;
export default PresentIcon